var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaverickLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logotipo.claro",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 338 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 320.5,
    y1: 50,
    x2: 320.5,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#5083c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5083c2"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "logotipo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "arrow",
    d: "M336.918,22l-15.918-22h-18l18,25-18,25h18l15.918-21c1.333-1.896,1.548-5.021,0-7Z",
    style: {
      fill: "url(#linear-gradient)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "technologies"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.88,41.22h-2.88v-1.554h7.634v1.554h-2.91v8.614h-1.845v-8.614Z",
    style: {
      fill: "#636466"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.174,45.324h-3.809v2.987h4.259v1.523h-6.104v-10.168h5.879v1.523h-4.034v2.626h3.809v1.509Z",
    style: {
      fill: "#636466"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.187,49.532c-.435.226-1.394.453-2.609.453-3.21,0-5.16-2.022-5.16-5.114,0-3.349,2.309-5.371,5.399-5.371,1.215,0,2.085.256,2.46.453l-.404,1.478c-.48-.211-1.14-.393-1.98-.393-2.055,0-3.54,1.297-3.54,3.742,0,2.233,1.306,3.666,3.525,3.666.75,0,1.529-.151,2.01-.377l.3,1.464Z",
    style: {
      fill: "#636466"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.308,39.666v4.073h4.274v-4.073h1.845v10.168h-1.845v-4.481h-4.274v4.481h-1.845v-10.168h1.845Z",
    style: {
      fill: "#636466"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.242,49.834v-10.168h2.099l2.609,4.36c.676,1.132,1.261,2.308,1.725,3.409h.029c-.119-1.357-.165-2.671-.165-4.225v-3.545h1.71v10.168h-1.904l-2.639-4.465c-.645-1.117-1.32-2.369-1.815-3.515l-.045.015c.075,1.313.09,2.655.09,4.33v3.636h-1.694Z",
    style: {
      fill: "#636466"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.05,44.644c0,3.41-2.054,5.356-4.844,5.356-2.849,0-4.649-2.187-4.649-5.174,0-3.123,1.95-5.326,4.799-5.326,2.955,0,4.694,2.247,4.694,5.144ZM206.506,44.795c0,2.067,1.034,3.711,2.805,3.711,1.785,0,2.79-1.659,2.79-3.786,0-1.915-.945-3.727-2.79-3.727-1.83,0-2.805,1.705-2.805,3.802Z",
    style: {
      fill: "#636466"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.34,39.666h1.845v8.614h4.154v1.554h-5.999v-10.168Z",
    style: {
      fill: "#636466"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.818,44.644c0,3.41-2.055,5.356-4.844,5.356-2.849,0-4.649-2.187-4.649-5.174,0-3.123,1.95-5.326,4.799-5.326,2.955,0,4.694,2.247,4.694,5.144ZM235.274,44.795c0,2.067,1.034,3.711,2.804,3.711,1.785,0,2.79-1.659,2.79-3.786,0-1.915-.945-3.727-2.79-3.727-1.83,0-2.804,1.705-2.804,3.802Z",
    style: {
      fill: "#636466"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.207,49.367c-.645.242-1.905.574-3.255.574-1.71,0-3-.438-3.96-1.358-.9-.86-1.425-2.202-1.41-3.741,0-3.213,2.28-5.28,5.625-5.28,1.245,0,2.22.256,2.684.483l-.405,1.493c-.555-.241-1.229-.437-2.295-.437-2.159,0-3.675,1.282-3.675,3.651,0,2.308,1.41,3.681,3.51,3.681.66,0,1.155-.091,1.395-.211v-2.535h-1.785v-1.463h3.57v5.145Z",
    style: {
      fill: "#636466"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.642,39.666v10.168h-1.845v-10.168h1.845Z",
    style: {
      fill: "#636466"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.11,45.324h-3.809v2.987h4.259v1.523h-6.104v-10.168h5.879v1.523h-4.034v2.626h3.809v1.509Z",
    style: {
      fill: "#636466"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.835,47.813c.601.347,1.5.648,2.445.648,1.185,0,1.845-.558,1.845-1.388,0-.769-.51-1.222-1.8-1.69-1.665-.603-2.729-1.494-2.729-2.957,0-1.66,1.38-2.927,3.569-2.927,1.095,0,1.905.242,2.43.513l-.449,1.494c-.36-.197-1.065-.483-2.01-.483-1.171,0-1.681.634-1.681,1.222,0,.785.585,1.147,1.935,1.675,1.755.664,2.609,1.554,2.609,3.017,0,1.629-1.229,3.048-3.84,3.048-1.064,0-2.175-.303-2.729-.634l.404-1.539Z",
    style: {
      fill: "#636466"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "downhole"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,39.801c.81-.136,1.845-.211,2.94-.211,1.89,0,3.196.392,4.126,1.177.975.8,1.576,2.007,1.576,3.741,0,1.81-.615,3.169-1.576,4.043-1.005.92-2.611,1.389-4.576,1.389-1.08,0-1.89-.061-2.49-.137v-10.002ZM1.845,48.416c.255.045.645.045,1.02.045,2.401.016,3.826-1.312,3.826-3.892.015-2.248-1.276-3.531-3.586-3.531-.585,0-1.005.046-1.26.106v7.271Z",
    style: {
      fill: "#636466"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.919,44.644c0,3.41-2.055,5.356-4.846,5.356-2.85,0-4.65-2.187-4.65-5.174,0-3.123,1.951-5.326,4.801-5.326,2.956,0,4.695,2.247,4.695,5.144ZM16.374,44.795c0,2.067,1.034,3.711,2.805,3.711,1.786,0,2.791-1.659,2.791-3.786,0-1.915-.946-3.727-2.791-3.727-1.831,0-2.805,1.705-2.805,3.802Z",
    style: {
      fill: "#636466"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.802,49.834l-2.476-10.168h1.965l.96,4.617c.256,1.237.495,2.534.66,3.545h.03c.165-1.071.45-2.278.735-3.561l1.095-4.601h1.935l1.005,4.676c.255,1.207.465,2.339.615,3.44h.03c.18-1.116.42-2.278.69-3.515l1.05-4.601h1.875l-2.716,10.168h-1.98l-1.05-4.783c-.255-1.162-.436-2.127-.556-3.228h-.029c-.181,1.086-.375,2.067-.675,3.228l-1.171,4.783h-1.995Z",
    style: {
      fill: "#636466"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.906,49.834v-10.168h2.1l2.61,4.36c.676,1.132,1.261,2.308,1.726,3.409h.029c-.119-1.357-.165-2.671-.165-4.225v-3.545h1.71v10.168h-1.905l-2.64-4.465c-.646-1.117-1.321-2.369-1.816-3.515l-.045.015c.075,1.313.09,2.655.09,4.33v3.636h-1.695Z",
    style: {
      fill: "#636466"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.594,39.666v4.073h4.275v-4.073h1.845v10.168h-1.845v-4.481h-4.275v4.481h-1.845v-10.168h1.845Z",
    style: {
      fill: "#636466"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.503,44.644c0,3.41-2.055,5.356-4.846,5.356-2.85,0-4.65-2.187-4.65-5.174,0-3.123,1.951-5.326,4.801-5.326,2.956,0,4.695,2.247,4.695,5.144ZM81.958,44.795c0,2.067,1.034,3.711,2.805,3.711,1.786,0,2.791-1.659,2.791-3.786,0-1.915-.945-3.727-2.791-3.727-1.83,0-2.805,1.705-2.805,3.802Z",
    style: {
      fill: "#636466"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.796,39.666h1.845v8.614h4.155v1.554h-6v-10.168Z",
    style: {
      fill: "#636466"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.549,45.324h-3.81v2.987h4.261v1.523h-6.106v-10.168h5.88v1.523h-4.035v2.626h3.81v1.509Z",
    style: {
      fill: "#636466"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "maverick"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "282 0 269.5 11 265.5 11 265.5 0 257 0 257 30 265.5 30 265.5 19 269.5 19 283 30 295 30 277 15 293 0 282 0",
    style: {
      fill: "#272525"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.11,0c-5.148,0-8.706.828-10.668,2.49-1.962,1.657-2.942,4.584-2.942,8.783v7.987c0,2.073.264,3.788.795,5.144.526,1.36,1.373,2.504,2.536,3.432,1.006.791,2.219,1.346,3.638,1.674,1.42.329,3.634.491,6.641.491h9.837c3.032,0,5.333-.148,6.901-.451,1.57-.3,2.826-.807,3.767-1.515.994-.735,1.724-1.71,2.189-2.933.464-1.218.696-2.766.696-4.642,0-.418-.019-1.056-.058-1.907l-.019-.217h-8.926v.316c0,1.544-.433,2.605-1.307,3.176-.869.57-2.707.854-5.508.854h-5.11c-2.827,0-4.719-.394-5.674-1.179-.954-.786-1.433-2.238-1.433-4.348v-4.072c0-2.363.431-3.912,1.289-4.654.857-.738,2.796-1.11,5.818-1.11h7.048c1.613,0,2.789.267,3.533.798.74.532,1.112,1.367,1.112,2.509v.293h8.829c.026-.212.042-.43.048-.658.007-.229.01-.561.01-.993,0-1.81-.216-3.314-.649-4.515-.432-1.203-1.106-2.155-2.021-2.863-.865-.682-2.046-1.167-3.544-1.454-1.497-.29-3.828-.435-6.99-.435h-9.837Z",
    style: {
      fill: "#272525"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203,
    width: 8.5,
    height: 30,
    style: {
      fill: "#272525"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.5,18c1.681-.431,2.784-1.239,3.5-2.5.715-1.266,1-2.907,1-5.5,0-3.734-.893-6.59-2.5-8-1.607-1.411-4.055-2-8.5-2h-23v30h8.5v-7.75h12.75c1.532,0,2.73.308,3.25.75.522.445,1,1.319,1,2.5v4.5h8.5v-6c0-1.52-.761-3.049-1.5-4-.739-.955-1.519-1.626-3-2ZM189.75,14c-.456.569-1.607.75-2.75.75h-13.5v-7.25h13.5c1.256,0,2.01.216,2.5.75.487.539.75,1.07.75,2.25,0,1.491-.041,2.928-.5,3.5Z",
    style: {
      fill: "#272525"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "131 0 131 30 161 30 161 22.5 139.5 22.5 139.5 18.25 159.5 18.25 159.5 11.75 139.5 11.75 139.5 7.5 161 7.5 161 0 131 0",
    style: {
      fill: "#272525"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "119.5 0 107.5 22 95.5 0 85.5 0 101.5 30 113.5 30 129.5 0 119.5 0",
    style: {
      fill: "#272525"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78,0h-12l-16,30h10l2.75-5h18.5l2.75,5h10L78,0ZM66.25,18l5.75-11,5.75,11h-11.5Z",
    style: {
      fill: "#272525"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "34 0 23.5 19 13 0 0 0 0 30 8.5 30 8.5 8.5 20.5 30 26.5 30 38.5 8.5 38.5 30 47 30 47 0 34 0",
    style: {
      fill: "#272525"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaverickLogo);
export default __webpack_public_path__ + "static/media/MaverickLogo.bf13be4edd15fc0a1191939febd90469.svg";
export { ForwardRef as ReactComponent };